import { render, staticRenderFns } from "./customButton.vue?vue&type=template&id=0660286b&scoped=true&"
import script from "./customButton.vue?vue&type=script&lang=js&"
export * from "./customButton.vue?vue&type=script&lang=js&"
import style0 from "./customButton.vue?vue&type=style&index=0&id=0660286b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0660286b",
  null
  
)

export default component.exports